var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "version_content"
  }, [_c('h2', [_vm._v(_vm._s(_vm.data.verCode))]), _c('div', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.data.verDate))]), _c('div', {
    staticClass: "content"
  }, _vm._l(_vm.contentList, function (name) {
    return _c('p', {
      key: name
    }, [_vm._v(_vm._s(name))]);
  }), 0), _c('Divider')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };